const DrawerSection = ({ title, children }) => (
    <section className="drawer-section">
        <h3>{title}</h3>
        {children}
    </section>
);

export default DrawerSection;
